/* Sukhara PDP — gallery, variant picker, ATC, FBT bundle, lightbox, sticky bar, pincode */
(function() {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function fmt(c) { return '₹' + (c / 100).toLocaleString('en-IN'); }

  document.addEventListener('DOMContentLoaded', function() {
    var pdp = $('[data-sk-pdp]');
    if (!pdp) return;

    // Variant-aware gallery must init BEFORE lightbox/dots so they read the active set.
    initVariantGallery(pdp);
    initMobileGalleryDots(pdp);
    initLightbox(pdp);
    initVariantPicker(pdp);
    initQty(pdp);
    initATC(pdp);
    initStickyBar(pdp);
    initPincode(pdp);
    initFBT(pdp);
    initShare(pdp);
  });

  // ============ Variant-aware gallery ============
  // Filters desktop tiles + mobile slides by the currently selected color value.
  // Exposes `pdp._skGallery.setActiveColor(color)` so initVariantPicker() can drive it.
  function initVariantGallery(pdp) {
    var DEBUG = true; // set false to silence
    function log() {
      if (!DEBUG || !window.console) return;
      var args = ['[SK PDP Gallery]'].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, args);
    }

    var colorValues = (pdp.getAttribute('data-color-values') || '').split('|').filter(Boolean);
    var initialColor = pdp.getAttribute('data-initial-color') || '';
    var optionIdx = parseInt(pdp.getAttribute('data-color-option-index') || '-1', 10);
    var debugOverrideRaw = pdp.getAttribute('data-debug-override-raw') || '';
    var debugOverrideFlat = pdp.getAttribute('data-debug-override-flat') || '';

    var desktopWrap = $('.sk-pdp__gallery', pdp);
    var mobileTrack = $('[data-sk-gallery-track]', pdp);
    var dotsWrap = $('[data-sk-gallery-dots]', pdp);

    log('init', {
      colorValues: colorValues,
      initialColor: initialColor,
      optionIdx: optionIdx,
      overrideRaw: debugOverrideRaw,
      overrideFlat: debugOverrideFlat
    });

    // Client-side fallback: if no tile in the DOM has data-color-tags set,
    // BUT we have metafield content (raw or flat), parse it ourselves and
    // assign tags from media position (1-based, in DOM order).
    function applyClientSideOverrideIfNeeded() {
      var tilesWithTags = $$('[data-sk-gallery-tile][data-color-tags]:not([data-color-tags=""])', pdp).length;
      if (tilesWithTags > 0) {
        log('  server-side tags present (' + tilesWithTags + ' tagged tiles) — skipping client fallback');
        return;
      }
      var sourceText = debugOverrideFlat || debugOverrideRaw;
      if (!sourceText) {
        log('  no override metafield present — tiles remain shared');
        return;
      }
      log('  ⚠ no server-side tags found — applying CLIENT-SIDE override from metafield');

      // Parse: prefer @N=color (already-flat) else look for "N":"color" or "N":color in JSON.
      var posToColor = {};
      // Flat form first
      var flatPairs = sourceText.split(';');
      flatPairs.forEach(function(p) {
        var kv = p.split('=');
        if (kv.length < 2) return;
        var k = kv[0].trim().toLowerCase();
        var v = kv[1].trim().toLowerCase();
        if (!k || !v) return;
        // Position keys: @N or bare N
        var m = k.match(/^@?(\d+)$/);
        if (m) posToColor[m[1]] = v;
      });
      // If still empty, fall back to JSON regex match on raw
      if (Object.keys(posToColor).length === 0 && debugOverrideRaw) {
        var jsonRegex = /"?(\d+)"?\s*:\s*"([^"]+)"/g;
        var match;
        while ((match = jsonRegex.exec(debugOverrideRaw)) !== null) {
          posToColor[match[1]] = match[2].toLowerCase();
        }
      }

      log('  parsed position→color map:', posToColor);

      // Apply to desktop tiles in DOM order (1-based)
      var desktopTiles = $$('[data-sk-gallery-tile]', pdp);
      var mobileTiles = $$('[data-sk-gallery-slide]', pdp);

      function tagByPosition(tilesArr) {
        tilesArr.forEach(function(tile, i) {
          var pos = (i + 1) + '';
          if (posToColor[pos]) {
            tile.setAttribute('data-color-tags', posToColor[pos]);
          }
        });
      }

      tagByPosition(desktopTiles);
      tagByPosition(mobileTiles);

      log('  client-side tagging complete. Sample:',
        desktopTiles.slice(0, 6).map(function(t, i) {
          return { pos: i + 1, tags: t.getAttribute('data-color-tags') };
        })
      );
    }

    applyClientSideOverrideIfNeeded();

    function tilesAll() {
      return $$('[data-sk-gallery-tile], [data-sk-gallery-slide]', pdp);
    }

    function tileMatchesColor(tile, color) {
      if (!color) return true;
      var raw = tile.getAttribute('data-color-tags') || '';
      if (raw === '') return true; // shared
      var tags = raw.split('|');
      for (var i = 0; i < tags.length; i++) {
        if (tags[i] === color) return true;
      }
      return false;
    }

    // Count how many tiles would match each color (per tile container, dedup desktop+mobile by media-id).
    function countMatchesByColor() {
      var byColor = {};
      colorValues.forEach(function(c) { byColor[c] = 0; });
      byColor['shared'] = 0;
      var seen = {};
      tilesAll().forEach(function(tile) {
        var mid = tile.getAttribute('data-media-id');
        if (seen[mid]) return;
        seen[mid] = true;
        var raw = tile.getAttribute('data-color-tags') || '';
        if (raw === '') {
          byColor['shared'] += 1;
        } else {
          raw.split('|').forEach(function(t) {
            if (byColor[t] != null) byColor[t] += 1;
          });
        }
      });
      return byColor;
    }

    function pauseHiddenMedia(tile) {
      // Pause any video that just got hidden so audio doesn't bleed.
      $$('video[data-sk-media-video]', tile).forEach(function(v) {
        try { v.pause(); v.currentTime = 0; } catch (_) {}
      });
      // For YouTube/Vimeo iframes, clear src so they stop playing.
      $$('iframe[data-sk-media-iframe]', tile).forEach(function(f) {
        if (f.src) { f.dataset._lastSrc = f.src; f.src = ''; }
      });
    }

    function reactivateMedia(tile) {
      // If iframe was cleared, restore from the data-embed-src or the saved last src
      $$('iframe[data-sk-media-iframe]', tile).forEach(function(f) {
        if (!f.src) {
          var restore = f.getAttribute('data-embed-src') || f.dataset._lastSrc;
          if (restore) f.src = restore;
        }
      });
      // Reveal model-viewer (we set reveal="manual" to defer init until visible)
      $$('model-viewer', tile).forEach(function(m) {
        if (typeof m.dismissPoster === 'function') {
          // no-op; model-viewer auto-loads when visible. Just trigger size recalc.
        }
      });
    }

    function rebuildDots() {
      if (!dotsWrap) return;
      var activeSlides = $$('[data-sk-gallery-slide][data-active="true"]', mobileTrack);
      dotsWrap.innerHTML = activeSlides.map(function(_, i) {
        return '<span class="sk-pdp__gallery-dot' + (i === 0 ? ' active' : '') + '" data-sk-gallery-dot></span>';
      }).join('');
    }

    // Apply story-layout: every 5th visible desktop tile gets the wide class
    // so it spans the full row (magazine-cover style).
    // Falls back to "all desktop tiles" when no [data-active] is set yet
    // (e.g. on initial paint before setActiveColor runs).
    function applyStoryLayout() {
      var activeTiles = $$('[data-sk-gallery-tile][data-active="true"]', pdp);
      if (activeTiles.length === 0) {
        // No tiles flagged active — default to ALL desktop tiles.
        activeTiles = $$('[data-sk-gallery-tile]', pdp).filter(function(t) {
          var s = (t.getAttribute('style') || '');
          return s.indexOf('display:none') === -1 && s.indexOf('display: none') === -1;
        });
      }
      activeTiles.forEach(function(tile, i) {
        var pos = i + 1;
        if (pos % 5 === 0) {
          tile.classList.add('sk-pdp__tile--wide');
        } else {
          tile.classList.remove('sk-pdp__tile--wide');
        }
      });
    }

    function setActiveColor(color, opts) {
      opts = opts || {};
      log('setActiveColor →', color);

      // First pass: figure out how many tiles would actually match.
      // If ZERO match, we fall back to "show all" so the page is never blank.
      var tiles = tilesAll();
      var matchedMediaIds = {};
      var matchedTilesCount = 0;
      tiles.forEach(function(tile) {
        if (tileMatchesColor(tile, color)) {
          matchedTilesCount++;
          matchedMediaIds[tile.getAttribute('data-media-id')] = true;
        }
      });
      log('  matched tiles =', matchedTilesCount, '/ unique media ids =', Object.keys(matchedMediaIds).length);

      var fallbackShowAll = matchedTilesCount === 0;
      if (fallbackShowAll) {
        log('  ⚠ no tiles matched color "' + color + '" — falling back to show ALL media. Check naming/metafield.');
      }

      // Crossfade
      if (desktopWrap) desktopWrap.classList.add('is-swapping');
      if (mobileTrack) mobileTrack.classList.add('is-swapping');

      var changed = 0;
      tiles.forEach(function(tile) {
        var match = fallbackShowAll ? true : tileMatchesColor(tile, color);
        var wasActive = tile.getAttribute('data-active') === 'true';
        if (match && !wasActive) {
          tile.setAttribute('data-active', 'true');
          tile.style.display = '';
          reactivateMedia(tile);
          changed++;
        } else if (!match && wasActive) {
          tile.removeAttribute('data-active');
          tile.style.display = 'none';
          pauseHiddenMedia(tile);
          changed++;
        }
      });
      log('  tiles toggled =', changed);

      // Reset mobile scroll to slide #1 of the new variant
      if (mobileTrack) {
        try { mobileTrack.scrollTo({ left: 0, behavior: 'instant' }); }
        catch (_) { mobileTrack.scrollLeft = 0; }
      }

      // Hero priority: first visible tile gets fetchpriority=high
      var firstActive = pdp.querySelector('[data-sk-gallery-tile][data-active="true"] img, [data-sk-gallery-slide][data-active="true"] img');
      if (firstActive) {
        $$('[data-sk-gallery-tile] img, [data-sk-gallery-slide] img', pdp).forEach(function(img) {
          img.setAttribute('fetchpriority', 'auto');
        });
        firstActive.setAttribute('fetchpriority', 'high');
        firstActive.setAttribute('loading', 'eager');
      }

      applyStoryLayout();

      rebuildDots();
      renderValidationPanel();

      // Notify lightbox to rebuild srcs
      pdp.dispatchEvent(new CustomEvent('sk:gallery-changed', { detail: { color: color, changed: changed, fallback: fallbackShowAll } }));

      // End crossfade
      setTimeout(function() {
        if (desktopWrap) desktopWrap.classList.remove('is-swapping');
        if (mobileTrack) mobileTrack.classList.remove('is-swapping');
      }, 180);
    }

    // Render the design-mode validation panel (theme editor only).
    function renderValidationPanel() {
      var list = pdp.querySelector('[data-sk-validation-list]');
      if (!list) return;
      var counts = countMatchesByColor();
      var html = '';
      Object.keys(counts).forEach(function(c) {
        var n = counts[c];
        var warn = (c !== 'shared' && n < 5) ? ' <em style="color:#B45200">— recommended 7+</em>' : '';
        html += '<li><strong>' + c + '</strong>: ' + n + ' media item' + (n === 1 ? '' : 's') + ' visible' + warn + '</li>';
      });
      list.innerHTML = html;
    }

    // Public surface
    pdp._skGallery = {
      setActiveColor: setActiveColor,
      colorValues: colorValues,
      optionIndex: optionIdx
    };

    // Coverage report (dev aid)
    if (window.console) {
      var coverage = countMatchesByColor();
      console.info('[Sukhara PDP] Variant media coverage:', coverage);
      var perTile = tilesAll().slice(0, 6).map(function(t) {
        return {
          mediaId: t.getAttribute('data-media-id'),
          mediaType: t.getAttribute('data-media-type'),
          tags: t.getAttribute('data-color-tags'),
          active: t.getAttribute('data-active') === 'true',
          surface: t.matches('[data-sk-gallery-tile]') ? 'desktop' : 'mobile'
        };
      });
      console.info('[Sukhara PDP] First 6 tile attributes:', perTile);
    }

    renderValidationPanel();

    // Always run the layout pass on first paint, even if no initial color is set
    // (so products without color variants still get the magazine-cover row).
    applyStoryLayout();

    // Initial sync (in case Liquid pre-render missed something — JS is the source of truth at runtime)
    if (initialColor) setActiveColor(initialColor);
  }

  // ============ Mobile gallery dots ============
  function initMobileGalleryDots(pdp) {
    var track = $('[data-sk-gallery-track]', pdp);
    var dots = $$('[data-sk-gallery-dot]', pdp);
    if (!track || !dots.length) return;
    var slides = $$('[data-sk-gallery-slide]', track);
    track.addEventListener('scroll', function() {
      clearTimeout(track._t);
      track._t = setTimeout(function() {
        var idx = Math.round(track.scrollLeft / (slides[0] ? slides[0].offsetWidth : 1));
        dots.forEach(function(d, i) { d.classList.toggle('active', i === idx); });
      }, 60);
    });
  }

  // ============ Image lightbox ============
  function initLightbox(pdp) {
    var lb = $('[data-sk-lightbox]', pdp);
    if (!lb) return;
    var img = $('[data-sk-lightbox-img]', lb);
    var closeBtn = $('[data-sk-lightbox-close]', lb);
    var prevBtn = $('[data-sk-lightbox-prev]', lb);
    var nextBtn = $('[data-sk-lightbox-next]', lb);
    var srcs = [];
    var idx = 0;

    function rebuildSrcs() {
      // Only collect sources from CURRENTLY ACTIVE tiles (variant-aware).
      // De-dupe on URL (mobile + desktop emit the same image).
      var seen = {};
      srcs = [];
      $$('[data-sk-gallery-tile][data-active="true"] img, [data-sk-gallery-slide][data-active="true"] img', pdp).forEach(function(el) {
        var src = el.getAttribute('data-full') || el.src;
        if (!src || seen[src]) return;
        seen[src] = true;
        srcs.push(src);
      });
    }

    function show(i) {
      if (!srcs.length) return;
      idx = (i + srcs.length) % srcs.length;
      img.src = srcs[idx];
      lb.classList.add('is-open');
      document.body.classList.add('sk-pdp-no-scroll');
    }
    function hide() { lb.classList.remove('is-open'); document.body.classList.remove('sk-pdp-no-scroll'); }

    // Click handler delegated to the section so it picks up tiles even after re-renders.
    pdp.addEventListener('click', function(e) {
      // Only trigger when the click is on an image-type tile (skip video/iframe controls)
      var tile = e.target.closest('[data-sk-gallery-tile][data-active="true"], [data-sk-gallery-slide][data-active="true"]');
      if (!tile) return;
      // Don't intercept clicks inside controls of <video>/<iframe>/<model-viewer>
      if (e.target.closest('video, iframe, model-viewer')) return;
      var mediaType = tile.getAttribute('data-media-type') || 'image';
      if (mediaType !== 'image') return;
      // Find this tile's image src and locate it in srcs
      rebuildSrcs();
      var imgEl = tile.querySelector('img');
      if (!imgEl) return;
      var src = imgEl.getAttribute('data-full') || imgEl.src;
      var i = srcs.indexOf(src);
      if (i < 0) i = 0;
      e.preventDefault();
      show(i);
    });

    if (closeBtn) closeBtn.addEventListener('click', hide);
    if (prevBtn) prevBtn.addEventListener('click', function() { show(idx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { show(idx + 1); });
    lb.addEventListener('click', function(e) { if (e.target === lb) hide(); });
    document.addEventListener('keydown', function(e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') hide();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });

    // When the gallery filters change, rebuild the source list and close lightbox if open.
    pdp.addEventListener('sk:gallery-changed', function() {
      rebuildSrcs();
      if (lb.classList.contains('is-open')) hide();
    });

    rebuildSrcs();
  }

  // ============ Variant picker ============
  function initVariantPicker(pdp) {
    var form = $('[data-sk-product-form]', pdp);
    if (!form) return;
    var dataEl = $('[data-sk-variants]', pdp);
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { console.error('PDP variants', e); return; }
    var idInput = $('[name="id"]', form);
    var priceEl = $('[data-sk-price]', pdp);
    var compareEl = $('[data-sk-price-compare]', pdp);
    var saveEl = $('[data-sk-price-save]', pdp);
    var emiEl = $('[data-sk-emi]', pdp);

    // Sticky bar elements
    var stickyPriceEl = $('[data-sk-sticky-price]', pdp);
    var stickyVariantEl = $('[data-sk-sticky-variant]', pdp);
    var stickyThumbImg = $('[data-sk-sticky-thumb-img]', pdp);
    var stickyCta = $('[data-sk-sticky-cta]', pdp);
    var stickyCtaLabel = stickyCta ? $('[data-sk-sticky-cta-label]', stickyCta) : null;

    var atcBtns = $$('[data-sk-atc-btn]', pdp);
    var colorNameEl = $('[data-sk-color-name]', pdp);

    function getOpts() {
      var fieldsets = $$('[data-sk-option]', form);
      return fieldsets.map(function(fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      // No fieldsets on the page → product has only the default variant
      if (opts.length === 0) {
        return variants[0];
      }
      return variants.find(function(v) {
        return v.options.length === opts.length && v.options.every(function(o, i) { return o === opts[i]; });
      });
    }

    function updateSizeAvailability() {
      var opts = getOpts();
      $$('[data-sk-option]', form).forEach(function(fs, fsIdx) {
        $$('input', fs).forEach(function(input) {
          var trial = opts.slice();
          trial[fsIdx] = input.value;
          var v = variants.find(function(vv) {
            return vv.options.every(function(o, i) {
              return i === fsIdx ? o === input.value : (trial[i] == null || o === trial[i]);
            });
          });
          var unavailable = !v || !v.available;
          input.disabled = !!unavailable;
          var label = input.closest('label');
          if (label) {
            label.classList.toggle('is-unavailable', !!unavailable);
            label.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
          }
        });
      });
    }

    // Update sticky bar thumbnail from the first active gallery image
    function updateStickyThumb() {
      if (!stickyThumbImg) return;
      var firstImg = pdp.querySelector(
        '[data-sk-gallery-tile][data-active="true"] img, ' +
        '[data-sk-gallery-slide][data-active="true"] img'
      );
      if (firstImg) {
        var newSrc = firstImg.src;
        if (newSrc && stickyThumbImg.src !== newSrc) {
          stickyThumbImg.src = newSrc;
        }
      }
    }

    function update() {
      var opts = getOpts();
      var v = findVariant(opts);
      if (!v) {
        atcBtns.forEach(function(b) { b.disabled = true; b.textContent = 'Unavailable'; });
        // Sticky: sold-out state for unknown variant
        if (stickyCta) {
          stickyCta.disabled = true;
          stickyCta.classList.add('sk-pdp__sticky-cta--soldout');
        }
        if (stickyCtaLabel) stickyCtaLabel.textContent = 'Unavailable';
        return;
      }

      idInput.value = v.id;

      // --- Main buy box price ---
      if (priceEl) priceEl.textContent = v.priceFormatted;
      if (compareEl) {
        if (v.compareAtPrice && v.compareAtPrice > v.price) {
          compareEl.textContent = v.compareAtFormatted;
          compareEl.style.display = '';
          if (saveEl) {
            var pct = Math.round((v.compareAtPrice - v.price) / v.compareAtPrice * 100);
            saveEl.textContent = '−' + pct + '%';
            saveEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }
      if (emiEl) {
        if (v.price >= 300000) {
          var emi = Math.ceil(v.price / 3 / 100) * 100;
          emiEl.innerHTML = 'or 3 interest-free EMIs of <strong>' + fmt(emi) + '</strong>';
          emiEl.style.display = '';
        } else {
          emiEl.style.display = 'none';
        }
      }

      // --- Sticky bar: price ---
      if (stickyPriceEl) stickyPriceEl.textContent = v.priceFormatted;

      // --- Sticky bar: selected variant name ---
      if (stickyVariantEl) {
        // Build the human-readable variant title from selected option values
        var selectedOpts = getOpts().filter(Boolean);
        stickyVariantEl.textContent = selectedOpts.join(' / ');
      }

      // --- Sticky bar: CTA state (sold-out / available) ---
      if (stickyCta) {
        if (!v.available) {
          stickyCta.disabled = true;
          stickyCta.classList.add('sk-pdp__sticky-cta--soldout');
          if (stickyCtaLabel) stickyCtaLabel.textContent = 'Sold Out';
        } else {
          stickyCta.disabled = false;
          stickyCta.classList.remove('sk-pdp__sticky-cta--soldout');
          if (stickyCtaLabel) stickyCtaLabel.textContent = 'Add to Bag';
        }
      }

      // Update color name label in buy-box header
      if (colorNameEl) {
        $$('[data-sk-option]', form).forEach(function(fs) {
          if (fs.getAttribute('data-sk-is-color') === 'true') {
            var checked = fs.querySelector('input:checked');
            if (checked) colorNameEl.textContent = checked.value;
          }
        });
      }

      // Drive the variant-aware gallery to filter by the newly selected color
      if (pdp._skGallery && pdp._skGallery.optionIndex >= 0) {
        var colorIdx = pdp._skGallery.optionIndex;
        var colorRaw = opts[colorIdx];
        if (colorRaw) {
          var colorNorm = String(colorRaw).toLowerCase().trim().replace(/\s+/g, '-');
          pdp._skGallery.setActiveColor(colorNorm);
        }
      }

      // --- Main ATC buttons ---
      atcBtns.forEach(function(btn) {
        if (!v.available) {
          btn.disabled = true;
          btn.textContent = 'Sold out';
        } else {
          btn.disabled = false;
          btn.dataset.label = btn.dataset.label || btn.textContent;
          btn.textContent = btn.dataset.label;
        }
      });

      updateSizeAvailability();

      // Defer thumbnail update until after gallery has filtered (gallery fires sk:gallery-changed)
      // We hook into it via the event, but also do a fast best-effort here.
      setTimeout(updateStickyThumb, 20);
    }

    // Also update thumbnail whenever the gallery finishes a color swap
    pdp.addEventListener('sk:gallery-changed', function() {
      setTimeout(updateStickyThumb, 200);
    });

    form.addEventListener('change', function(e) {
      if (e.target.matches('input[type="radio"]')) update();
    });
    // Block clicks on disabled options
    form.addEventListener('click', function(e) {
      var label = e.target.closest('label.is-unavailable');
      if (label) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    update();
  }

  // ============ Quantity ============
  function initQty(pdp) {
    var input = $('[data-sk-qty-input]', pdp);
    if (!input) return;
    var dec = $('[data-sk-qty-dec]', pdp);
    var inc = $('[data-sk-qty-inc]', pdp);
    if (dec) dec.addEventListener('click', function() { input.stepDown(); input.dispatchEvent(new Event('change')); });
    if (inc) inc.addEventListener('click', function() { input.stepUp(); input.dispatchEvent(new Event('change')); });
  }

  // ============ ATC (uses mini-cart.renderContents) ============
  function getCartSections() {
    var miniCart = document.querySelector('mini-cart');
    if (!miniCart || typeof miniCart.getSectionsToRender !== 'function') {
      return ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
    }
    return miniCart.getSectionsToRender().map(function(s) { return s.section; });
  }

  function performAdd(items, btn) {
    var miniCart = document.querySelector('mini-cart');
    var sections = getCartSections();
    var body = { items: items, sections: sections.join(','), sections_url: window.location.pathname };
    var addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js';

    if (btn) {
      btn.disabled = true;
      btn._origText = btn.textContent;
      btn.textContent = 'Adding...';
    }

    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(err) { throw new Error(err.description || err.message || 'Add failed'); });
        return r.json();
      })
      .then(function(state) {
        if (btn) btn.textContent = '✓ Added';
        if (miniCart && typeof miniCart.renderContents === 'function' && state && state.sections) {
          miniCart.renderContents(state);
        } else {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.openMenuDrawer === 'function') drawer.openMenuDrawer();
        }
        setTimeout(function() {
          if (btn) { btn.textContent = btn._origText; btn.disabled = false; }
        }, 900);
      })
      .catch(function(err) {
        console.error('ATC error', err);
        if (btn) { btn.textContent = (err && err.message) || 'Try again'; setTimeout(function() { btn.textContent = btn._origText; btn.disabled = false; }, 2200); }
      });
  }

  function initATC(pdp) {
    var form = $('[data-sk-product-form]', pdp);
    if (!form) return;

    // Track which trigger initiated the submit so we can show loading on the right button
    var pendingTrigger = null; // 'main' | 'sticky'

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value || '1', 10);

      if (pendingTrigger === 'sticky') {
        // Show loading on the sticky CTA button
        var stickyCtaEl = $('[data-sk-sticky-cta]', pdp);
        performAdd([{ id: id, quantity: qty }], stickyCtaEl);
      } else {
        // Show loading on the main ATC button
        var mainBtn = form.querySelector('[data-sk-atc-btn]');
        performAdd([{ id: id, quantity: qty }], mainBtn);
      }
      pendingTrigger = null;
    });

    // Main ATC button: direct form submit (pendingTrigger stays null → 'main' path)
    // The form's submit button already triggers submit natively.

    // Sticky CTA: sets trigger flag then calls requestSubmit
    var stickyBtn = $('[data-sk-sticky-cta]', pdp);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        pendingTrigger = 'sticky';
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else {
          // Fallback: call performAdd directly to avoid full page reload
          var id = form.querySelector('[name="id"]').value;
          var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value || '1', 10);
          performAdd([{ id: id, quantity: qty }], stickyBtn);
          pendingTrigger = null;
        }
      });
    }
  }

  function initStickyBar(pdp) {
    var sticky = $('[data-sk-sticky]', pdp);
    var hero = $('[data-sk-hero]', pdp);
    if (!sticky || !hero) return;

    // Mobile (< 990px): always visible — skip IntersectionObserver entirely.
    // The CSS forces transform:translateY(0) with !important on mobile, so we
    // only need the observer on desktop to add/remove .is-visible.
    function isDesktop() { return window.innerWidth >= 990; }

    if (!isDesktop()) {
      // On mobile we still want the is-visible class present for any JS that checks it
      sticky.classList.add('is-visible');
      return;
    }

    // Desktop: slide up after hero scrolls out of view.
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, {
      threshold: 0,
      rootMargin: '0px 0px 0px 0px'
    });
    observer.observe(hero);

    // Re-evaluate on resize (tablet ↔ desktop breakpoint crossing)
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (!isDesktop()) {
          observer.disconnect();
          sticky.classList.add('is-visible');
        }
      }, 150);
    });
  }

  function initPincode(pdp) {
    var input = $('[data-sk-pincode-input]', pdp);
    var btn = $('[data-sk-pincode-btn]', pdp);
    var msg = $('[data-sk-pincode-msg]', pdp);
    if (!input || !btn || !msg) return;
    function check() {
      var v = (input.value || '').trim();
      if (!/^\d{6}$/.test(v)) {
        msg.className = 'sk-pdp__pincode-msg is-error';
        msg.textContent = 'Please enter a valid 6-digit pincode';
        return;
      }
      var firstThree = v.substring(0, 3);
      if (firstThree === '560') {
        msg.className = 'sk-pdp__pincode-msg is-success';
        msg.textContent = '✓ Same-day dispatch · Delivery in 1-2 days';
      } else if (['110','201','400','411','600','700','500'].indexOf(firstThree) > -1) {
        msg.className = 'sk-pdp__pincode-msg is-success';
        msg.textContent = '✓ Delivery in 3-5 days · COD available';
      } else {
        msg.className = 'sk-pdp__pincode-msg is-success';
        msg.textContent = '✓ Delivery in 5-7 days';
      }
      try { localStorage.setItem('sk_pin', v); } catch (_) {}
    }
    btn.addEventListener('click', check);
    input.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
    try { var saved = localStorage.getItem('sk_pin'); if (saved) { input.value = saved; check(); } } catch (_) {}
  }

  function initFBT(pdp) {
    var fbt = $('[data-sk-fbt]', pdp);
    if (!fbt) return;
    var dataEl = $('[data-sk-fbt-data]', fbt);
    if (!dataEl) return;
    var items = [];
    try { items = JSON.parse(dataEl.textContent); } catch (e) { console.error('FBT parse', e); return; }
    var DT = parseInt(fbt.getAttribute('data-fbt-threshold') || '3', 10);
    var DP = parseInt(fbt.getAttribute('data-fbt-percent') || '10', 10);
    var checkboxes = $$('[data-sk-fbt-check]', fbt);
    var totalEl = $('[data-sk-fbt-total]', fbt);
    var strikeEl = $('[data-sk-fbt-strike]', fbt);
    var savingsEl = $('[data-sk-fbt-savings]', fbt);
    var msgEl = $('[data-sk-fbt-msg]', fbt);
    var ctaBtn = $('[data-sk-fbt-cta]', fbt);

    function update() {
      var subtotal = 0, count = 0;
      checkboxes.forEach(function(cb, i) {
        var card = cb.closest('[data-sk-fbt-item]');
        if (cb.checked) { subtotal += items[i].price; count++; if (card) card.classList.add('is-checked'); }
        else if (card) card.classList.remove('is-checked');
      });
      var hasDisc = count >= DT;
      var discount = hasDisc ? Math.round(subtotal * DP / 100) : 0;
      var finalT = subtotal - discount;
      if (totalEl) totalEl.textContent = fmt(finalT);
      if (strikeEl) {
        if (hasDisc) { strikeEl.style.display = ''; strikeEl.textContent = fmt(subtotal); }
        else strikeEl.style.display = 'none';
      }
      if (savingsEl) {
        if (hasDisc) { savingsEl.textContent = 'You save ' + fmt(discount) + ' (' + DP + '%)'; savingsEl.style.display = ''; }
        else savingsEl.style.display = 'none';
      }
      if (msgEl) {
        if (count === 0) { msgEl.className = 'sk-pdp__fbt-msg'; msgEl.textContent = 'Select items to add to cart'; }
        else if (hasDisc) { msgEl.className = 'sk-pdp__fbt-msg is-success'; msgEl.textContent = '🎉 ' + DP + '% bundle discount unlocked'; }
        else {
          var need = DT - count;
          msgEl.className = 'sk-pdp__fbt-msg is-prompt';
          msgEl.textContent = need === 1 ? '✨ Add 1 more to unlock ' + DP + '% off' : '✨ Add ' + need + ' more to unlock ' + DP + '% off';
        }
      }
      if (ctaBtn) {
        ctaBtn.disabled = count === 0;
        ctaBtn.textContent = count === 0 ? 'Select items' : 'Add ' + count + (count === 1 ? ' item' : ' items') + ' to cart — ' + fmt(finalT);
      }
    }
    checkboxes.forEach(function(cb) { cb.addEventListener('change', update); });
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function() {
        var toAdd = [];
        checkboxes.forEach(function(cb, i) { if (cb.checked) toAdd.push({ id: items[i].id, quantity: 1 }); });
        if (!toAdd.length) return;
        performAdd(toAdd, ctaBtn);
      });
    }
    update();
  }

  function initShare(pdp) {
    var copyBtn = $('[data-sk-share-copy]', pdp);
    if (!copyBtn) return;
    copyBtn.addEventListener('click', function() {
      navigator.clipboard.writeText(window.location.href).then(function() {
        var orig = copyBtn.textContent;
        copyBtn.textContent = '✓ Copied';
        setTimeout(function() { copyBtn.textContent = orig; }, 1500);
      });
    });
  }

  // ============ ROOM BUNDLE (Style In Your Room) ============
  function initRoom(pdp) {
    var room = $('[data-sk-room]', pdp);
    if (!room) return;
    var dataEl = $('[data-sk-room-data]', room);
    if (!dataEl) return;
    var items = [];
    try { items = JSON.parse(dataEl.textContent); } catch (e) { console.error('Room parse', e); return; }
    var DT = parseInt(room.getAttribute('data-room-threshold') || '3', 10);
    var DP = parseInt(room.getAttribute('data-room-percent') || '10', 10);
    var checks = $$('[data-sk-room-check]', room);
    var totalEl = $('[data-sk-room-total]', room);
    var strikeEl = $('[data-sk-room-strike]', room);
    var savingsEl = $('[data-sk-room-savings]', room);
    var msgEl = $('[data-sk-room-msg]', room);
    var ctaBtn = $('[data-sk-room-cta]', room);
    var origCtaText = ctaBtn ? ctaBtn.textContent : '';

    function update() {
      var subtotal = 0, count = 0;
      checks.forEach(function(cb, i) {
        var card = cb.closest('[data-sk-room-card]');
        if (cb.checked) { subtotal += items[i].price; count++; if (card) card.classList.add('is-checked'); }
        else if (card) card.classList.remove('is-checked');
      });
      var hasDisc = count >= DT;
      var discount = hasDisc ? Math.round(subtotal * DP / 100) : 0;
      var finalT = subtotal - discount;
      if (totalEl) totalEl.textContent = fmt(finalT);
      if (strikeEl) {
        if (hasDisc) { strikeEl.style.display = ''; strikeEl.textContent = fmt(subtotal); }
        else strikeEl.style.display = 'none';
      }
      if (savingsEl) {
        if (hasDisc) { savingsEl.textContent = 'You save ' + fmt(discount) + ' (' + DP + '%)'; savingsEl.style.display = ''; }
        else savingsEl.style.display = 'none';
      }
      if (msgEl) {
        if (count === 0) { msgEl.className = 'sk-pdp__room-msg'; msgEl.textContent = 'Select items to bring this room home'; }
        else if (hasDisc) { msgEl.className = 'sk-pdp__room-msg is-success'; msgEl.textContent = '🎉 ' + DP + '% room bundle discount unlocked'; }
        else {
          var need = DT - count;
          msgEl.className = 'sk-pdp__room-msg is-prompt';
          msgEl.textContent = need === 1 ? '✨ Add 1 more to unlock ' + DP + '% off the room' : '✨ Add ' + need + ' more to unlock ' + DP + '% off the room';
        }
      }
      if (ctaBtn) {
        ctaBtn.disabled = count === 0;
        if (count === 0) ctaBtn.textContent = 'Select items';
        else ctaBtn.textContent = origCtaText + ' — ' + fmt(finalT);
      }
    }
    checks.forEach(function(cb) { cb.addEventListener('change', update); });
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function() {
        var toAdd = [];
        checks.forEach(function(cb, i) { if (cb.checked) toAdd.push({ id: items[i].id, quantity: 1 }); });
        if (!toAdd.length) return;
        performAdd(toAdd, ctaBtn);
      });
    }
    update();
  }

  // ============ SEEN IN REAL HOMES — open in main lightbox ============
  function initRealHomes(pdp) {
    var lb = $('[data-sk-lightbox]', pdp);
    if (!lb) return;
    var img = $('[data-sk-lightbox-img]', lb);
    function open(src) {
      img.src = src;
      lb.classList.add('is-open');
      document.body.classList.add('sk-pdp-no-scroll');
    }
    $$('[data-sk-realhomes-tile]', pdp).forEach(function(tile) {
      tile.addEventListener('click', function() {
        var src = tile.getAttribute('data-img');
        if (src) open(src);
      });
    });
    $$('[data-sk-reviews-photo]', pdp).forEach(function(tile) {
      tile.addEventListener('click', function() {
        var src = tile.getAttribute('data-img');
        if (src) open(src);
      });
    });
  }

  // ============ Photo teaser → smooth scroll to reviews ============
  function initPhotoTeaser(pdp) {
    var teaser = $('[data-sk-photo-teaser]', pdp);
    if (!teaser) return;
    teaser.addEventListener('click', function(e) {
      e.preventDefault();
      var target = $('#sk-pdp-reviews', pdp);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    var ratingRow = $('.sk-pdp__rating-row', pdp);
    if (ratingRow) {
      ratingRow.addEventListener('click', function(e) {
        e.preventDefault();
        var target = $('#sk-pdp-reviews', pdp);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  // ============ Delivery-by date computation ============
  function initDeliveryCue(pdp) {
    var lineEl = $('[data-sk-delivery-text]', pdp);
    if (!lineEl) return;

    function computeRange(daysFrom, daysTo) {
      var now = new Date();
      var from = new Date(now.getTime() + daysFrom * 86400000);
      var to = new Date(now.getTime() + daysTo * 86400000);
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var sameMonth = from.getMonth() === to.getMonth();
      if (sameMonth) {
        return 'Delivery by ' + months[from.getMonth()] + ' ' + from.getDate() + '–' + to.getDate();
      }
      return 'Delivery by ' + months[from.getMonth()] + ' ' + from.getDate() + ' – ' + months[to.getMonth()] + ' ' + to.getDate();
    }

    function setForPincode(pin) {
      var first = (pin || '').substring(0, 3);
      if (first === '560') {
        lineEl.textContent = computeRange(1, 2) + ' · Same-day dispatch';
      } else if (['110','201','400','411','600','700','500'].indexOf(first) > -1) {
        lineEl.textContent = computeRange(3, 5);
      } else if (pin && /^\d{6}$/.test(pin)) {
        lineEl.textContent = computeRange(5, 7);
      } else {
        lineEl.textContent = computeRange(3, 7);
      }
    }

    try {
      var saved = localStorage.getItem('sk_pin');
      setForPincode(saved || '');
    } catch (_) { setForPincode(''); }

    // Watch pincode input for live updates
    var pinInput = $('[data-sk-pincode-input]', pdp);
    var pinBtn = $('[data-sk-pincode-btn]', pdp);
    if (pinBtn) pinBtn.addEventListener('click', function() {
      setTimeout(function() { setForPincode((pinInput || {}).value || ''); }, 30);
    });
  }

  // Hook the new initializers
  document.addEventListener('DOMContentLoaded', function() {
    var pdp = $('[data-sk-pdp]');
    if (!pdp) return;
    initRoom(pdp);
    initRealHomes(pdp);
    initPhotoTeaser(pdp);
    initDeliveryCue(pdp);
  });
})();
